import { CreditCardModel } from "../../../core/models/credit-card.model";
import { getEnvModel } from "../../../core/models/env.model";
import { GlobalConfig } from "../../../core/models/global-config.model";
import { PaymentGatewayModel } from "../../../core/models/payment-gateway.model";
import { UiStringModel } from "../../../core/models/ui-string.model";
import DataService from "../../../core/services/data.service";
import { CheckoutViewModel } from "../checkout.vm";

declare class FatZebraSDK {
    constructor(options: { username: string; test?: boolean });
    checkout(): void;
    on(event: string, callback: (e: any) => void): void;
    renderPaymentsPage(options: any): void;
    renderClickToPay(options: any): void;
}

declare var FatZebra: any;

// docs https://docs.fatzebra.com/docs/javascript-sdk-overview
export class CheckoutFatZebra {
    private fz: FatZebraSDK;
    private checkoutModel: CheckoutViewModel;
    private creditCard: CreditCardModel;
    private paymentGateway: PaymentGatewayModel;
    constructor(
        private readonly paymentGatewayId: KnockoutObservable<number>,
        private readonly shoppingCartTotalAmount: KnockoutObservable<number>,
        private readonly setErrorMessage: (error: string) => void,
        private readonly processPayment: (card: CreditCardModel) => void,
        private readonly uiStrings: UiStringModel,
        private readonly global: GlobalConfig,
        private readonly dataService: DataService,
    ) {
        this.fz = null;
        this.creditCard = null;
        this.paymentGateway = null;
        this.checkoutModel = null;
    }

    public async purchase() {
        if (typeof (this.paymentGateway) !== "undefined" && this.paymentGateway !== null && this.paymentGateway.clickToPayEnabled === true && this.creditCard !== null) {
            await this.processPayment(this.creditCard);
        }
        else {
            this.fz.checkout();
        }
    }

    public async initialise(gateway: PaymentGatewayModel, email: String, checkout: CheckoutViewModel) {
        try {
            if (typeof (this.creditCard) !== "undefined" && this.creditCard !== null) {
                return;
            }
            this.paymentGateway = gateway;
            this.checkoutModel = checkout;
            const amountInCents = Math.round(this.shoppingCartTotalAmount() * 100);
            const verification = `ref_123490:${amountInCents}:${this.uiStrings.currencyCode.toUpperCase()}:true`;
            const clickToPayVerification = `ref_123490:${this.shoppingCartTotalAmount()}:${this.uiStrings.currencyCode.toUpperCase()}`;
            const cssPath = `${getEnvModel().checkoutSitePath}/checkoutresources/bundle/fat-zebra.css`;

            const { token, verificationCode, cssSignature, clickToPayVerificationToken } = await $.when(
                this.dataService.GetFatZebraToken(gateway.paymentGatewayId),
                this.dataService.CalculateVerification(verification, gateway.paymentGatewayId),
                this.dataService.CalculateVerification(cssPath, gateway.paymentGatewayId),
                this.dataService.CalculateVerification(clickToPayVerification, gateway.paymentGatewayId),
                $.getScript({ url: this.global.config.fatZebraApiUrl, cache: true, dataType: 'script' }),
            ).then((token, verificationCode, cssSignature, clickToPayVerificationToken) => ({ token: token[0], verificationCode: verificationCode[0], cssSignature: cssSignature[0], clickToPayVerificationToken: clickToPayVerificationToken[0] }));

            localStorage.setItem('fz-access-token', token);

            this.fz = new FatZebra({ username: gateway.username });

            if (email === "") {
                $("#fz-paynow").css("display", "block");

                this.fz.renderPaymentsPage({
                    containerId: "fz-paynow",
                    paymentIntent: {
                        payment: {
                            amount: amountInCents,
                            currency: this.uiStrings.currencyCode.toUpperCase(),
                            reference: "ref_123490",
                        },
                        verification: verificationCode
                    },
                    options: { // Hpp display options
                        hideButton: true,
                        hideLogos: true,
                        enableSca: false,
                        tokenizeOnly: true,
                        googlepay: false,

                        applepay: false,
                        hide_card_holder: true,
                        css: cssPath,
                        css_signature: cssSignature
                    }
                });
            }
            else {
                $("#fz-clicktopay").css("display", "block");
                $("#fz-clicktopaymessage").css("display", "none");

                this.fz.renderClickToPay({
                    containerId: 'fz-clicktopay',
                    paymentIntent: {
                        payment: {
                            amount: this.shoppingCartTotalAmount(),
                            currency: this.uiStrings.currencyCode.toUpperCase(),
                            reference: "ref_123490",
                        },
                        verification: clickToPayVerificationToken,
                    },
                    options: {
                        email: email,
                        //mobile: "0491 571 266",
                        css: cssPath,
                        css_signature: cssSignature,
                        hideConfirmButton: true,
                        hideManualEntryLink: true,
                        tokenizeOnly: true
                    }
                });
            }


            this.fz.on('fz.form_validation.error', (e) => this.onValidationError(e.detail));
            this.fz.on('fz.tokenization.error', (e) => this.onTokenError(e.detail));
            this.fz.on('fz.tokenization.success', (e) => this.onTokenSuccess(e.detail));
            var messageListener = async function (event: any) {
                if ('data' in event === false) {
                    return
                }

                switch (event.data.subject) {
                    case "fz.click_to_pay.resize":
                        if (typeof (this.creditCard) == "undefined" || this.creditCard == null) {
                            $("#fz-clicktopay").css("height", event.data.data.heightPx);
                            $("#fz-clicktopay > iframe").css("height", event.data.data.heightPx);
                        }
                        break;
                    case "fz.click_to_pay.tokenization.success":
                        const token = event?.data?.data?.gatewayResponse?.token || event?.data?.gatewayResponse?.token;

                        const card = await this.dataService.RetrieveFatZebraTokenizedCard(token, this.paymentGateway.paymentGatewayId); // only used to get country

                        const creditCard: CreditCardModel = {
                            ccBin: event.data.data.gatewayResponse.cardNumber.substring(0, 6),
                            cardToken: event.data.data.gatewayResponse.token,
                            last4Digits: event.data.data.clickToPayResponse.panLastFour,
                            cardCountry: card.cardCountry,
                            cardBrand: event.data.data.gatewayResponse.cardType,
                        };
                        this.creditCard = creditCard;

                        $("#fz-clicktopay").css("display", "none");
                        $("#fz-clicktopaymessage").css("display", "block");
                        $("#fz-clicktopaymessage").text("Your card has been selected.");
                        this.checkoutModel.disablePurchase(false);

                        break;
                }
            };

            window.addEventListener("message", messageListener.bind(this));
        }
        catch (error) {
            this.dataService.LogJavascriptWarning(error);
            throw error;
        }
    }

    public async onTokenSuccess(event: { message: string, data: { token: string } }) {
        const card = await this.dataService.RetrieveFatZebraTokenizedCard(event.data.token, this.paymentGatewayId());

        const creditCard: CreditCardModel = {
            ccBin: card.cardFirst6,
            cardToken: event.data.token,
            last4Digits: card.cardLast4,
            cardCountry: card.cardCountry,
            cardBrand: card.cardType
        };

        await this.processPayment(creditCard);
    }

    private onTokenError(error: { message: string, errors: string[], data: any }) {
        console.error(error);
        this.dataService.LogJavascriptWarning(error as any);
        this.setErrorMessage(error.errors[0]);
    }

    private onValidationError(error: { message: string, errors: string[], data: any }) {
        console.error(error);
        this.setErrorMessage(error.errors[0]);
    }
}